import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthenticatedContext } from '@ktag/commons';
import useAppState from '../../AppStore';

/// This component notifies the user when the session has expired.
export const SessionExpiredNotification = () => {
  const { t } = useTranslation('agisviewer');
  const isLoggedIn = useAppState((state) => state.isLoggedIn);
  const addNotification = useAppState((state) => state.addNotification);
  const removeNotification = useAppState((state) => state.removeNotification);
  const notificationId = 'sessionExpired';
  const user = useAuthenticatedContext();

  // remove notificate on the first render since the notifcation should only be displayed after the user has logged in and the session has expired.
  useEffect(() => removeNotification(notificationId), []);

  useEffect(() => {
    if (!isLoggedIn) return undefined;
    if (!user) return undefined;

    removeNotification(notificationId);
    return () => {
      addNotification({
        id: notificationId,
        title: t('session_timeout_notification_title'),
        message: t('session_timeout_notification'),
        type: 'negative',
      });
    };
  }, [isLoggedIn]);

  return undefined;
};
